import apiClient from "../apiClient";

//................. Auth Api's...................//

export const loginUser = (userId, password) =>
  apiClient.post("/Login", {
    UserID: userId,
    Password: password,
    LoginTypeID: 1,
    Longitude: 0,
    Latitude: 0,
  });
